module.exports = __webpack_public_path__ + "static/img/build01.1119e2d5.png";